var map = {
	"./essar.png": 41545,
	"./gotour.png": 7351,
	"./jabbar-travels.png": 55669,
	"./kanker.png": 24055,
	"./laxmi-holidays.png": 82562,
	"./limoliner.png": 4180,
	"./neetabus.png": 87290,
	"./nuego.png": 48517,
	"./rajesh-transport.png": 12770,
	"./rajkalpana.png": 47248,
	"./shyamoli.png": 29949,
	"./sps-luxury.png": 10621,
	"./svkdt.png": 79585,
	"./tsrtc.png": 52703,
	"./vignesh-tat.png": 47203,
	"./yolobus.png": 46980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50744;